import React, { useMemo } from 'react';
import PreviewQuestionShell from './PreviewQuestionShell';

const RatingQuestionBlock = ({ question, register, errors, watch }) => {
    const minValue = Number(question.minValue) > 0 ? Number(question.minValue) : 1;
    const maxValue = Number(question.maxValue) >= minValue ? Number(question.maxValue) : 5;
    const ratingType = question.ratingType || 'stars';
    const fieldName = question.internalId;
    const currentValue = Number(watch(fieldName)) || 0;
    const requiredRule = question.required ? `${question.title || 'Rating'} is required` : false;

    const values = useMemo(
        () => Array.from({ length: maxValue - minValue + 1 }, (_, index) => minValue + index),
        [minValue, maxValue]
    );

    return (
        <PreviewQuestionShell question={question} error={errors[fieldName]?.message}>
            <div className="ecx-survey-preview-rating">
                {ratingType === 'stars' ? (
                    <div className="ecx-survey-preview-rating__stars" role="radiogroup">
                        {values.map((ratingValue) => (
                            <label key={ratingValue} className="ecx-survey-preview-rating__star">
                                <input
                                    type="radio"
                                    value={ratingValue}
                                    className="visually-hidden"
                                    {...register(fieldName, { required: requiredRule })}
                                />
                                <i
                                    className={`bi ${
                                        ratingValue <= currentValue ? 'bi-star-fill' : 'bi-star'
                                    }`}
                                    aria-hidden="true"
                                />
                            </label>
                        ))}
                    </div>
                ) : null}

                {ratingType === 'numbers' ? (
                    <div className="ecx-survey-preview-rating__numbers" role="radiogroup">
                        {values.map((ratingValue) => (
                            <label
                                key={ratingValue}
                                className={`ecx-survey-preview-rating__number${
                                    currentValue === ratingValue ? ' is-active' : ''
                                }`}
                            >
                                <input
                                    type="radio"
                                    value={ratingValue}
                                    className="visually-hidden"
                                    {...register(fieldName, { required: requiredRule })}
                                />
                                {ratingValue}
                            </label>
                        ))}
                    </div>
                ) : null}

                {ratingType === 'scale' ? (
                    <div className="ecx-survey-preview-rating__scale">
                        <div className="ecx-survey-preview-rating__scale-value">
                            {currentValue || minValue} / {maxValue}
                        </div>
                        <input
                            type="range"
                            className="form-range"
                            min={minValue}
                            max={maxValue}
                            step={1}
                            defaultValue={minValue}
                            {...register(fieldName, {
                                required: requiredRule,
                                valueAsNumber: true,
                            })}
                        />
                    </div>
                ) : null}

                <div className="ecx-survey-preview-rating__labels">
                    <span>{question.minLabel || 'Poor'}</span>
                    <span>{question.maxLabel || 'Excellent'}</span>
                </div>
            </div>
        </PreviewQuestionShell>
    );
};

export default RatingQuestionBlock;
